import React from 'react';
import { AccentedText } from '../AccentedText/AccentedText';
import './StepBlock.scss';

export const StepBlock = ({ node }) => {
    const bodyCollection = node.relationships?.field_header_body_collection;
    const stepCount = bodyCollection?.length;
    if (
        !bodyCollection ||
        stepCount > 4 ||
        stepCount < 3 ||
        bodyCollection?.some(
            (step) => !step.field_heading || !step.field_content_text
        )
    ) {
        return (
            <p className="component-error">
                ERROR: Step Block: Min 3/Max 4 steps required with heading/body
                text for each step.
                <br />
            </p>
        );
    }
    return (
        <ol
            className={`step-block step-size-${stepCount} themed-container ${
                node.field_dark_mode ? `dark` : `light gray`
            }`}
        >
            {bodyCollection?.map((step, idx) => {
                return (
                    <li className="step" key={idx}>
                        <h3 className="typestack-title-3">
                            <span>
                                <AccentedText>
                                    {step.field_heading}
                                </AccentedText>
                            </span>
                        </h3>
                        <div
                            className="typestack-body-2"
                            dangerouslySetInnerHTML={{
                                __html: step.field_content_text?.value,
                            }}
                        ></div>
                    </li>
                );
            })}
        </ol>
    );
};
